<!-- eslint-disable max-len -->
<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99992 17.2917C11.9338 17.2917 13.7885 16.5235 15.1559 15.1561C16.5234 13.7886 17.2916 11.934 17.2916 10.0001C17.2916 8.06621 16.5234 6.21155 15.1559 4.84409C13.7885 3.47664 11.9338 2.70841 9.99992 2.70841C8.06605 2.70841 6.21138 3.47664 4.84393 4.84409C3.47648 6.21155 2.70825 8.06621 2.70825 10.0001C2.70825 11.934 3.47648 13.7886 4.84393 15.1561C6.21138 16.5235 8.06605 17.2917 9.99992 17.2917ZM9.99992 18.3334C7.78978 18.3334 5.67016 17.4554 4.10736 15.8926C2.54456 14.3298 1.66658 12.2102 1.66658 10.0001C1.66658 7.78994 2.54456 5.67033 4.10736 4.10753C5.67016 2.54472 7.78978 1.66675 9.99992 1.66675C12.2101 1.66675 14.3297 2.54472 15.8925 4.10753C17.4553 5.67033 18.3333 7.78994 18.3333 10.0001C18.3333 12.2102 17.4553 14.3298 15.8925 15.8926C14.3297 17.4554 12.2101 18.3334 9.99992 18.3334Z"
      fill="#334D6E"
    />
    <path
      d="M8.1988 13.0677C8.28399 13.1116 8.37963 13.1311 8.4752 13.1241C8.57076 13.1171 8.66255 13.0839 8.74046 13.0281L11.5623 10.0005V12.6042C11.5623 12.7423 11.6172 12.8748 11.7149 12.9724C11.8126 13.0701 11.945 13.125 12.0832 13.125C12.2213 13.125 12.3538 13.0701 12.4515 12.9724C12.5491 12.8748 12.604 12.7423 12.604 12.6042V7.39583C12.604 7.25769 12.5491 7.12522 12.4515 7.02754C12.3538 6.92987 12.2213 6.87499 12.0832 6.87499C11.945 6.87499 11.8126 6.92987 11.7149 7.02754C11.6172 7.12522 11.5623 7.25769 11.5623 7.39583V10.0005L8.73942 6.97187C8.66154 6.91642 8.5699 6.88348 8.47455 6.87665C8.37919 6.86982 8.28379 6.88936 8.1988 6.93315C8.11382 6.97693 8.04252 7.04326 7.99273 7.12487C7.94293 7.20648 7.91656 7.30023 7.9165 7.39583V12.6042C7.9164 12.6999 7.9427 12.7938 7.9925 12.8756C8.0423 12.9574 8.11368 13.0239 8.1988 13.0677Z"
      fill="#334D6E"
    />
  </svg>
</template>
<script>
export default {
  name: 'getStarted',
};
</script>
